module.exports = __webpack_public_path__ + "static/media/STATISTICS_MOBILE.ef7b85e5.png";